<script>
export default {
    name: 'KeyHandler',

    data() {
        return {
            key: '',
        }
    },

    created() {
        this.updateKey()
    },

    methods: {
        updateKey() {
            this.key = Date.now()
        },
    },
}
</script>
